import {
    BONUS,
    CATEGORY_ACCOUNT_DEBIT_VIA_MODULR,
    CATEGORY_ACCOUNT_DEBIT_VIA_PLAID,
    CATEGORY_TRANSFER_FROM_ACH,
    CATEGORY_TRANSFER_FROM_APPLE_PAY,
    CATEGORY_TRANSFER_FROM_BANK_ACCOUNT,
    CATEGORY_TRANSFER_FROM_BLIK,
    CATEGORY_TRANSFER_FROM_EPS,
    CATEGORY_TRANSFER_FROM_FLINKS,
    CATEGORY_TRANSFER_FROM_GIROPAY,
    CATEGORY_TRANSFER_FROM_GOOGLE_PAY,
    CATEGORY_TRANSFER_FROM_IDEAL,
    CATEGORY_TRANSFER_FROM_INTERAC,
    CATEGORY_TRANSFER_FROM_LEAN,
    CATEGORY_TRANSFER_FROM_MBWAY,
    CATEGORY_TRANSFER_FROM_MYBANK,
    CATEGORY_TRANSFER_FROM_PEOPLE_TRUST_INTERAC,
    CATEGORY_TRANSFER_FROM_SOFORT,
    CATEGORY_TRANSFER_FROM_KLARNA,
    CATEGORY_TRANSFER_FROM_TRUSTLY,
    CATEGORY_TRANSFER_FROM_TINK,
    CATEGORY_TRANSFER_FROM_USA_BANK_ACCOUNT,
    DC,
    EXTERNAL,
    PAYMENT_BANK_ACCOUNT,
    PAYMENT_BANK_CARD,
} from 'constants/Constants';
import {
    ACCEPTED_PAYMENT,
    ACTUAL_TILL,
    BILL_ISSUER,
    BILL_ISSUER_COMMENT,
    DELIVERY_METHOD,
    FIRST_PIN_FIELD,
    FOURTH_PIN_FIELD,
    FROM_PRV_ID,
    ID,
    INVITE_CODE_FIELD,
    KEEP_AMOUNT,
    NAME,
    NAME_F,
    PAYMENT_METHOD,
    PHONE,
    PROMO_CODE_FIELD,
    SECOND_PIN_FIELD,
    SOURCE,
    SOURCE_CARD_CVV,
    SOURCE_CODE_FROM,
    SPECIAL_FIELD_PREFIX,
    THIRD_PIN_FIELD,
    TO_NAME,
    TO_NAME_F,
    TO_PRV_ID,
} from 'constants/fieldsName';
import { PAN } from 'constants/FieldType';
import { PRECHEQUE_FORM } from 'constants/formName';
import { DEFAULT_PHONE_REGEX } from 'constants/utilsMasks';

import update from 'helpers/Immutability';
import { getExtra } from 'helpers/utils';

export const getCaptchaURL = () => {
    return `/api/i/captcha.check?r=${Math.floor(Math.random() * 100000000000000000)}`;
};

export const getLang = (countryCode, defaultLang) => {
    return countryCode === 'ca' || countryCode === 'us' ? 'en' : defaultLang;
};

export const getSortFields = (fields) => {
    const fieldsArray = Array.isArray(fields) ? fields : Object.values(fields);
    fieldsArray.sort((a, b) => {
        if (a.order < b.order) {
            return -1;
        }
        if (b.order < a.order) {
            return 1;
        }
        return 0;
    });
    return fieldsArray.filter((field) => {
        const dependentFiledName = field?.showOnFieldSelectionName;
        if (dependentFiledName) {
            const dependentField = fieldsArray.find((f) => f.name === dependentFiledName);
            return dependentField?.value === field?.showOnFieldSelectionValue;
        }
        return true;
    });
};

export const validationAndUpdateValue = (formName, value, field, changeFormField, binInfoError) => {
    let isError = false;
    let trimValue = typeof value === 'string' || value instanceof String ? value.trim() : value;
    let unicodeFlag = field?.checkRegexp?.includes('p{L}') || field?.checkRegexp?.includes('p{M}');
    if (field?.type === PAN && (binInfoError || (field.errorCode && field.errorCode !== 0))) {
        isError = true;
    } else if (field.mandatory === true && !field.checkRegexp) {
        if (formName === PRECHEQUE_FORM && SOURCE_CARD_CVV) {
            const regexp = '^\\d{3}$';
            const valid = new RegExp(regexp, unicodeFlag ? 'u' : '');
            isError = !valid.test(trimValue);
        } else {
            isError = !trimValue;
        }
    } else if (field.mandatory === true) {
        const valid = new RegExp(field.checkRegexp, unicodeFlag ? 'u' : '');
        isError = !valid.test(trimValue);
    } else if (field.mandatory === false && field.checkRegexp && trimValue) {
        const valid = new RegExp(field.checkRegexp, unicodeFlag ? 'u' : '');
        isError = !valid.test(trimValue);
    }

    let newField;
    if (isError) {
        newField = update(field, {
            value: { $set: value },
            isError: { $set: isError },
        });
    } else {
        newField = update(field, {
            value: { $set: value },
            isError: { $set: isError },
            errorCode: { $set: null },
        });
    }

    if (changeFormField) {
        changeFormField(formName, newField);
    }
    return Promise.resolve(newField);
};

export const notValidateUpdateValue = (formName, value, field, changeFormField) => {
    let newValue = value;
    if (field.name === TO_NAME || field.name === TO_NAME_F || field.name === NAME || field.name === NAME_F) {
        const capitalizedFirstLetter = value.charAt(0).toUpperCase();
        newValue = `${capitalizedFirstLetter}${value.slice(1)}`;
    }
    const newField = update(field, {
        value: { $set: newValue },
    });
    changeFormField(formName, newField);
    return Promise.resolve(newField);
};

export const shouldValidateNumberFormat = (iso2, countriesToValidate, countries) => {
    const country = countries.find(({ code }) => code === iso2);
    if (!country || !countriesToValidate) return false;
    const countryId = String(country.id);
    const normalizedFromString = String(countriesToValidate)
        .split(',')
        .map((s) => s.trim());
    const list = Array.isArray(countriesToValidate) ? countriesToValidate.map(String) : normalizedFromString;
    return list.includes(countryId);
};

export const clearErrorField = (formName, oldField, changeFormField) => {
    const errorMessage = oldField.errorMessage;
    let newField;
    if (errorMessage) {
        newField = update(oldField, {
            isError: { $set: false },
            errorMessage: { $set: null },
            errorCode: { $set: null },
        });
    } else {
        newField = update(oldField, {
            isError: { $set: false },
        });
    }

    changeFormField(formName, newField);
    return Promise.resolve(newField);
};

export const changePinToFields = () => {
    const fields = {};

    fields.pin = getField('pin', '');
    return fields;
};

export const validationOnRequiredAndReturnErrorFields = (formName, fields, changeFormField, checkNotVisibleField = true) => {
    const errorFields = [];
    getSortFields(fields).forEach((field) => {
        if ((checkNotVisibleField || field.visible) && !field.name.includes(SPECIAL_FIELD_PREFIX)) {
            if (field.isError) {
                errorFields.push(field);
                if (__isDev__) {
                    console.log('field "%s" \t is error!: ', field.name, field);
                }
            } else if (field.mandatory && !field.value) {
                let newField = update(field, {
                    $auto: { isError: { $set: true } },
                });
                if (field.parentField && Array.isArray(field.items) && !field.items.length) {
                    newField = update(field, {
                        $auto: { isError: { $set: false } },
                    });
                } else {
                    errorFields.push(field);
                    if (__isDev__) {
                        console.log('field "%s" \t is empty!: ', field.name, field);
                    }
                }
                changeFormField(formName, newField);
            }
        }
    });
    return errorFields;
};

export const getEmptyMandatoryOrFieldsWithError = (fields, checkNotVisibleField = true, addLogInfo = true) => {
    const errorFields = [];
    getSortFields(fields).forEach((field) => {
        if (checkNotVisibleField || field.visible) {
            if (field.isError || (field.errorCode && field.errorCode !== 0)) {
                errorFields.push(field);
                if (__isDev__ && addLogInfo) {
                    console.log('field "%s" \t is error!: ', field.name, field);
                }
            } else if (field.mandatory && !field.value) {
                if (__isDev__ && addLogInfo) {
                    console.log('field "%s" \t is empty!: ', field.name, field);
                }
                const newField = update(field, {
                    $auto: { isError: { $set: true } },
                });
                errorFields.push(newField);
            }
        }
    });
    return errorFields;
};
export const getEmptyNotValidFields = (fields, checkNotVisibleField = true, addLogInfo = true) => {
    const errorFields = [];
    getSortFields(fields).forEach((field) => {
        if (checkNotVisibleField || field.visible) {
            if (field.isError || (field.errorCode && field.errorCode !== 0)) {
                errorFields.push(field);
                if (__isDev__ && addLogInfo) {
                    console.log('field "%s" \t is error!: ', field.name, field);
                }
            } else if (!field.value && field.mandatory) {
                if (__isDev__ && addLogInfo) {
                    console.log('field "%s" \t is empty!: ', field.name, field);
                }
                const newField = update(field, {
                    $auto: { isError: { $set: true } },
                });
                errorFields.push(newField);
            } else if (field.checkRegexp && field.value) {
                let trimValue = typeof field.value === 'string' || field.value instanceof String ? field.value.trim() : field.value;
                let unicodeFlag = field?.checkRegexp?.includes('p{L}') || field?.checkRegexp?.includes('p{M}');
                const valid = new RegExp(field.checkRegexp, unicodeFlag ? 'u' : '');
                if (!valid.test(trimValue)) {
                    errorFields.push(field);
                    if (__isDev__ && addLogInfo) {
                        console.log('field "%s" \t is error!: ', field.name, field);
                    }
                }
            }
        }
    });
    return errorFields;
};

export const convertFieldsToSearchParams = (fields = {}, isGetCanonicalPath = false) => {
    const data = new URLSearchParams();
    Object.values(fields).forEach((field) => {
        let trimValue = typeof field.value === 'string' || field.value instanceof String ? field.value.trim() : field.value;
        if (trimValue && (field.canonicalPath || field.name)) {
            data.append(isGetCanonicalPath && field.canonicalPath ? field.canonicalPath : field.name, trimValue);
        }
    });
    return data;
};

export const getField = (
    name = 'name',
    value = '',
    checkRegexp = '',
    mandatory = false,
    isError = false,
    placeholder = '',
    type = 'text',
    visible = true,
    canonicalPath = false,
    order = null,
) => {
    return {
        name: name,
        value: value,
        checkRegexp: checkRegexp,
        mandatory: mandatory,
        isError: isError,
        placeholder: placeholder,
        type: type,
        visible: visible,
        canonicalPath: canonicalPath ? `toValues[${name}]` : null,
        order: order,
    };
};

export const toAmountToFields = (toValues, amountField, countryId) => {
    return amountToFields(toValues, amountField, countryId, false);
};

export const fromAmountToFields = (toValues = [], amountField = {}, countryId) => {
    return amountToFields(toValues, amountField, countryId);
};

export const smsConfirmationToFields = (smsConfirmation, redirectUrl) => {
    const fields = {};

    fields.objectId = getField('objectId', smsConfirmation.objectId);
    fields.objectType = getField('objectType', smsConfirmation.objectType);
    fields.code = getField('code', smsConfirmation.code);
    fields.payId = getField('payId', smsConfirmation.payId);
    fields.redirect = getField('redirect', redirectUrl);

    return fields;
};

export const deactivateAccountDisclaimerFields = () => {
    const fields = {};

    fields.disclaimerAgree = getField('disclaimerAgree', true);
    return fields;
};

const amountToFields = (toValues = [], amountField = {}, countryId, isFrom = true) => {
    const fields = {};
    if (amountField.name) {
        fields[amountField.name] = getField(
            amountField.name,
            toValues[amountField.name] ? toValues[amountField.name] : '',
            '(\\d{1,3} ){0,5}\\d{1,3}(\\.\\d{0,2}){0,1}',
            true,
            false,
            amountField.placeholder,
            'tel',
            true,
            true,
            isFrom ? -2 : -1,
        );
    }
    if (amountField.currencyName) {
        fields[amountField.currencyName] = getField(amountField.currencyName, amountField.currencyId, '', true, false, '', 'number', true, true);
    }
    const cnrIdName = `__sys_pay_${isFrom ? 'from' : 'to'}_cnr_id`;
    fields[cnrIdName] = getField(cnrIdName, countryId, '', true, false, '', 'number', true, true);
    return fields;
};
export const getFieldsForCreateRequest = (data, messages = {}) => {
    return getFieldsForRequest(true, data, messages);
};

const getFieldsForRequest = (isCreate = true, data, messages = {}) => {
    const requestForm = data.requestForm ? data.requestForm : {};
    const requestInfo = data.requestInfo ? data.requestInfo : {};
    const sourceCodeFrom = getExtra(requestForm.sourceCodeFrom, 'type') === EXTERNAL ? null : requestForm.sourceCodeFrom;

    const fromFields = fromAmountToFields(requestForm.toValues, requestForm.fromAmount, requestInfo.countryFromId);
    Object.values(fromFields).forEach((field) => (field.mandatory = false));

    let cardFields = {};
    const method = isCreate ? requestForm.deliveryMethod : requestForm.paymentSourceFromMethod;
    if (method === PAYMENT_BANK_CARD) {
        cardFields = cardToFields(requestForm.toValues, requestInfo.card);
        Object.values(cardFields).forEach((field) => (field.visible = true));
    }
    if (method === BONUS) {
        cardFields = cardToFields(requestForm.toValues, requestInfo.card);
    }
    let accountFields = {};
    if (method === PAYMENT_BANK_ACCOUNT) {
        accountFields = fieldsToObject(requestForm.toValues, requestInfo.account);
        Object.values(accountFields).forEach((field) => (field.visible = true));
    }

    const fields = {
        ...toAmountToFields(requestForm.toValues, requestForm.toAmount, requestInfo.countryToId),
        ...fromFields,
        ...cardFields,
        ...accountFields,
        ...(isCreate ? requestInfo.fieldsTo : {}),
        ...(!isCreate ? requestInfo.fieldsFrom : {}),
        ...(!isCreate ? {} : { [PHONE]: getField(PHONE, '', DEFAULT_PHONE_REGEX, true, false, messages.requestPhonePlaceholder, 'tel', true, false, -3) }),
        ...{ [BILL_ISSUER_COMMENT]: getField(BILL_ISSUER_COMMENT, '', '', false, false, messages.requestCommentPlaceholder, 'text', true, false) },
        ...(isCreate ? {} : { [SOURCE]: getField(SOURCE, sourceCodeFrom, null, false, false, null, 'text', false, true) }),
        ...{
            [SOURCE_CODE_FROM]: getField(SOURCE_CODE_FROM, requestForm.sourceCodeFrom),
        },
        ...{
            [PAYMENT_METHOD]: getField(PAYMENT_METHOD, requestForm.paymentSourceFromMethod),
        },
        ...{
            [DELIVERY_METHOD]: getField(DELIVERY_METHOD, requestForm.deliveryMethod),
        },
        ...{
            [ACTUAL_TILL]: getField(
                ACTUAL_TILL,
                requestForm.toValues ? requestForm.toValues[ACTUAL_TILL] : null,
                requestForm.actualTill ? requestForm.actualTill?.checkRegexp : null,
                requestForm.actualTill?.mandatory,
                false,
                messages.requestActualTillPlaceholder,
                'date',
                true,
                true,
            ),
        },
        ...{
            [FROM_PRV_ID]: getField(FROM_PRV_ID, requestForm[FROM_PRV_ID]),
        },
        ...{
            [TO_PRV_ID]: getField(TO_PRV_ID, requestForm[TO_PRV_ID]),
        },
        ...{
            [BILL_ISSUER]: getField(BILL_ISSUER, requestForm[BILL_ISSUER]),
        },
        ...{
            [ID]: getField(ID, requestForm[ID]),
        },
        ...{
            [ACCEPTED_PAYMENT]: getField(ACCEPTED_PAYMENT, requestForm[ACCEPTED_PAYMENT]),
        },
    };
    addFieldToFields(fields, requestForm.actualTill);

    return fields;
};

export const getFieldsForSend = (data) => {
    const paymentInfo = data.paymentInfo ? data.paymentInfo : {};
    const paymentForm = data.paymentForm;
    const countryMenu = data.countryMenu;
    const sourceCodeFrom = getExtra(paymentForm?.sourceCodeFrom, 'type') === EXTERNAL ? null : paymentForm?.sourceCodeFrom;
    let fields = {
        ...toAmountToFields(paymentForm.toValues, paymentForm.toAmount, countryMenu.countryTo.id),
        ...fromAmountToFields(paymentForm.toValues, paymentForm.fromAmount, countryMenu.countryFrom.id),
        ...fieldsToObject(paymentForm.toValues, paymentInfo.fieldsTo),
        ...fieldsToObject(paymentForm.toValues, paymentInfo.fieldsFrom),
        ...cardToFields(paymentForm.toValues, paymentInfo.card, paymentInfo),
        ...cardToFields(paymentForm.toValues, paymentInfo.cardTo),
        ...fieldsToObject(paymentForm.toValues, paymentInfo.account),
        ...fieldsToObject(paymentForm.toValues, paymentInfo.accountTo),
        ...{
            [KEEP_AMOUNT]: getField(KEEP_AMOUNT, true),
        },
        ...{
            [DELIVERY_METHOD]: getField(DELIVERY_METHOD, paymentForm.deliveryMethod),
        },
        ...{
            [PAYMENT_METHOD]: getField(PAYMENT_METHOD, paymentForm.paymentSourceFromMethod),
        },
        ...{
            [TO_PRV_ID]: getField(TO_PRV_ID, paymentForm.toPrvId),
        },
        ...{
            [FROM_PRV_ID]: getField(FROM_PRV_ID, paymentForm.fromPrvId),
        },
        ...{
            [SOURCE_CODE_FROM]: getField(SOURCE_CODE_FROM, sourceCodeFrom),
        },
        ...{
            [SOURCE]: getField(SOURCE, sourceCodeFrom, null, false, false, '', 'text', false, true),
        },
    };
    if (paymentForm.toValues[INVITE_CODE_FIELD]) {
        fields = update(fields, {
            [INVITE_CODE_FIELD]: { $set: getField(INVITE_CODE_FIELD, paymentForm.toValues[INVITE_CODE_FIELD], null, false, false, null, 'text', false, true) },
        });
    }
    if (paymentForm.toValues[PROMO_CODE_FIELD]) {
        fields = update(fields, {
            [PROMO_CODE_FIELD]: { $set: getField(PROMO_CODE_FIELD, paymentForm.toValues[PROMO_CODE_FIELD], null, false, false, null, 'text', false, true) },
        });
    }
    return fields;
};

export const getFieldsForGaPlasticPin = () => {
    return {
        [FIRST_PIN_FIELD]: getField(FIRST_PIN_FIELD, '', '', false, false, '', 'text', true, true),
        [SECOND_PIN_FIELD]: getField(SECOND_PIN_FIELD, '', '', false, false, '', 'text', true, true),
        [THIRD_PIN_FIELD]: getField(THIRD_PIN_FIELD, '', '', false, false, '', 'text', true, true),
        [FOURTH_PIN_FIELD]: getField(FOURTH_PIN_FIELD, '', '', false, false, '', 'text', true, true),
    };
};
export const getFieldsForGaPlasticAddress = (objValues, objPlaceholders) => {
    const { countryPlaceholder, postcodePlaceholder, streetPlaceholder, flatPlaceholder, cityPlaceholder } = objPlaceholders;
    const CITY = 'city',
        ADDRESS = 'address',
        ADDRESS2 = 'address2',
        COUNTRY_ID = 'country_id',
        POSTAL_CODE = 'postal_code';
    return {
        [CITY]: getField(CITY, objValues[CITY] || '', '^.{2,200}$', true, false, cityPlaceholder, 'text', true, true, 5),
        [ADDRESS]: getField(ADDRESS, objValues[ADDRESS] || '', '^.{5,1000}$', true, false, streetPlaceholder, 'text', true, true, 3),
        [ADDRESS2]: getField(
            ADDRESS2,
            objValues[ADDRESS2] || '',
            '^[0-9a-zA-ZàâäôéèëêïîçùûüÿæœÀÂÄÔÉÈËÊÏÎŸÇÙÛÜÆŒ&-_ ,./]{1,1000}$',
            false,
            false,
            flatPlaceholder,
            'text',
            true,
            true,
            4,
        ),
        [COUNTRY_ID]: getField(COUNTRY_ID, objValues[COUNTRY_ID] || '', '^.{1,200}$', true, false, countryPlaceholder, 'phone_country', true, true, 1),
        [POSTAL_CODE]: getField(POSTAL_CODE, objValues[POSTAL_CODE] || '', null, true, false, postcodePlaceholder, 'text', true, true, 2),
    };
};

export const fieldsToObject = (toValues, fields) => {
    const p = {};
    if (fields) {
        if (Array.isArray(fields)) {
            fields.forEach((field) => {
                addFieldToFields(toValues, p, field);
            });
        } else if (fields) {
            Object.keys(fields).forEach((key) => {
                addFieldToFields(toValues, p, fields[key]);
            });
        }
    }
    return p;
};

const addFieldToFields = (toValues, fields, field) => {
    if (field) {
        if (toValues[field.name]) {
            field.value = toValues[field.name];
        }
        fields[field.name] = { ...field, visible: true };
    }
};

const extraToObject = (stringExtra) => {
    const extra = {};
    if (stringExtra) {
        stringExtra.split(';').forEach((e) => {
            const se = e.split('=');
            if (se[0] && se[0].length > 0) {
                extra[se[0]] = se[1];
            }
        });
    }
    return extra;
};

export const cardToFields = (toValues, card, paymentInfo = {}) => {
    const p = {};
    if (card) {
        const extra = extraToObject(toValues[SOURCE]);
        addFieldToFields(toValues, p, card.pan);
        addFieldToFields(toValues, p, card.cardExpired);
        addFieldToFields(toValues, p, card.cvv);
        if (extra.type === DC && card.pan && card.pan.name.indexOf('from_') !== -1) {
            if (card.pan && p[card.pan.name]) {
                p[card.pan.name].isReadOnly = true;
                p[card.pan.name].value = paymentInfo.sources?.from?.[paymentInfo.sourceFrom]?.account ?? '';
            }
            if (card.cardExpired && p[card.cardExpired.name]) {
                p[card.cardExpired.name].isReadOnly = true;
                p[card.cardExpired.name].value = paymentInfo.sources?.from?.[paymentInfo.sourceFrom]?.cardExpired ?? '';
            }
        }
        p[SOURCE] = getField(SOURCE, card.source, '', false, false, '', 'text', true, true);
    }

    return p;
};

export const showSourceInfo = (source) => {
    return (
        source.categoryId !== CATEGORY_TRANSFER_FROM_BANK_ACCOUNT &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_USA_BANK_ACCOUNT &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_APPLE_PAY &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_GOOGLE_PAY &&
        source.categoryId !== CATEGORY_ACCOUNT_DEBIT_VIA_MODULR &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_TRUSTLY &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_TINK &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_LEAN &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_MYBANK &&
        source.categoryId !== CATEGORY_ACCOUNT_DEBIT_VIA_PLAID &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_INTERAC &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_PEOPLE_TRUST_INTERAC &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_FLINKS &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_ACH &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_SOFORT &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_KLARNA &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_IDEAL &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_BLIK &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_EPS &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_MBWAY &&
        source.categoryId !== CATEGORY_TRANSFER_FROM_GIROPAY
    );
};

export const hasContacts = () =>
    __isBrowser__ && navigator && 'contacts' in navigator && 'select' in navigator.contacts && 'getProperties' in navigator.contacts;

export const getContact = () => {
    return new Promise((resolve, reject) => {
        if (hasContacts()) {
            navigator.contacts
                .getProperties()
                .then((availableProperties) => {
                    if (availableProperties.includes('address')) {
                        navigator.contacts.select(['name', 'tel'], { multiple: false }).then((contacts) => {
                            if (!!contacts.length && !!contacts[0].tel.length) {
                                const [firstTel] = contacts[0].tel;
                                firstTel && resolve(firstTel);
                            } else {
                                if (__isDev__) console.log('Tel property is empty');
                                reject(null);
                            }
                        });
                    } else {
                        if (__isDev__) console.log(`Contact Picker API on your device doesn't support name or tel property`);
                        reject(null);
                    }
                })
                .catch((error) => {
                    if (__isDev__) console.log('Unexpected error happened in Contact Picker API', error);
                    reject(null);
                });
        } else {
            if (__isDev__) console.log(`Your browser doesn't support Contact Picker API`);
            reject(null);
        }
    });
};

export const getContacts = () => {
    return new Promise((resolve, reject) => {
        if (hasContacts()) {
            navigator.contacts
                .getProperties()
                .then((availableProperties) => {
                    if (availableProperties.includes('address')) {
                        navigator.contacts.select(['name', 'tel'], { multiple: true }).then((contacts) => {
                            if (!!contacts.length && !!contacts[0].tel.length) {
                                resolve(contacts);
                            } else {
                                if (__isDev__) console.log('Tel property is empty');
                                reject(null);
                            }
                        });
                    } else {
                        if (__isDev__) console.log(`Contact Picker API on your device doesn't support name or tel property`);
                        reject(null);
                    }
                })
                .catch((error) => {
                    if (__isDev__) console.log('Unexpected error happened in Contact Picker API', error);
                    reject(null);
                });
        } else {
            if (__isDev__) console.log(`Your browser doesn't support Contact Picker API`);
            reject(null);
        }
    });
};
